import { Orientation } from "../../../interfaces";

export default {
  // Agile Coaches
  0x00: {
    thumbnail: '/assets/images/thumbnails/AgileCoaches/rwanda.jpg',
    imageUrl: '/assets/images/bigImages/AgileCoaches/rwanda.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2020/4/agile-coaching-in-rwanda',
    description: 'Agile Coaching in Rwanda',
    orientation: Orientation.NORTH
  },
  0x01: {
    thumbnail: '/assets/images/thumbnails/AgileCoaches/hacksite.jpg',
    imageUrl: '/assets/images/bigImages/AgileCoaches/hacksite.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2018/11/hacksite',
    description: 'Ideas Engineering Hacksite',
    orientation: Orientation.EAST
  },
  0x02: {
    thumbnail: '/assets/images/thumbnails/AgileCoaches/wagenburg.jpeg',
    imageUrl: '/assets/images/bigImages/AgileCoaches/wagenburg.jpeg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2019/8/plaedoyer-fuer-die-wagenburg',
    description: 'Plädoyer für die Wagenburg',
    orientation: Orientation.EAST
  },
  // A-Team
  0x03: {
    thumbnail: '/assets/images/thumbnails/ATeam/feel-good.jpg',
    imageUrl: '/assets/images/bigImages/ATeam/feel-good.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2019/6/feel-good-management',
    description: 'Was ist eigentlich dieses Feel Good Management?',
    orientation: Orientation.EAST
  },
  0x04: {
    thumbnail: '/assets/images/thumbnails/ATeam/mobile-office.jpg',
    imageUrl: '/assets/images/bigImages/ATeam/mobile-office.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2020/6/what-does-a-feelgood-manager-do-in-mobile-office',
    description: 'What does a Feelgood Manager do in Mobile Office?',
    orientation: Orientation.EAST
  },
  0x05: {
    thumbnail: '/assets/images/thumbnails/ATeam/moving.png',
    imageUrl: '/assets/images/bigImages/ATeam/moving.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/moving-part-one-the-donation',
    description: 'Moving Part One: What to Do with Remaining Inventory?',
    orientation: Orientation.EAST
  },
  // Mac & Cheese
  0x06: {
    thumbnail: '/assets/images/thumbnails/MacCheese/checkpointcovid.png',
    imageUrl: '/assets/images/bigImages/MacCheese/checkpointcovid.png',
    blogPostUrl: 'https://medium.com/axel-springer-tech/checkpointcovid-983b796748d1',
    description: 'CheckpointCovid',
    orientation: Orientation.EAST
  },
  0x07: {
    thumbnail: '/assets/images/thumbnails/MacCheese/codeandplay.jpg',
    imageUrl: '/assets/images/bigImages/MacCheese/codeandplay.jpeg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2020/3/from-lernwerkstatt-to-code-and-play',
    description: 'From Lernwerkstatt to Code&Play … in 5 days',
    orientation: Orientation.EAST
  },
  0x08: {
    thumbnail: '/assets/images/thumbnails/MacCheese/wirvsvirus.png',
    imageUrl: '/assets/images/bigImages/MacCheese/wirvsvirus.png',
    blogPostUrl: 'https://medium.com/axel-springer-tech/wirvsvirushack-d761656fad0d',
    description: '#wirvsvirushack',
    orientation: Orientation.EAST
  },
  // Rochen
  0x09: {
    thumbnail: '/assets/images/thumbnails/Rochen/emperor.png',
    imageUrl: '/assets/images/bigImages/Rochen/emperor.png',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2020/9/styling-the-emperors-new-clothes',
    description: 'The Emperor\'s New Clothes\n',
    orientation: Orientation.EAST
  },
  0x0a: {
    thumbnail: '/assets/images/thumbnails/Rochen/hackathon.png',
    imageUrl: '/assets/images/bigImages/Rochen/hackathon.png',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2020/5/how-we-conduct-hackathons-in-home-office',
    description: 'How we conduct Hackathons in Home Office',
    orientation: Orientation.EAST
  },
  // UX
  0x0b: {
    thumbnail: '/assets/images/thumbnails/TeamUX/designsprint.jpg',
    imageUrl: '/assets/images/bigImages/TeamUX/designsprint.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2020/6/remote-design-sprint',
    description: 'Remote Design Sprint',
    orientation: Orientation.EAST
  },
  // Team X
  0x0c: {
    thumbnail: '/assets/images/thumbnails/TeamX/blockchain.jpg',
    imageUrl: '/assets/images/bigImages/TeamX/blockchain.jpeg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2020/9/2020-is-blockchain-still-a-thing',
    description: '2020 — Is Blockchain still a thing?',
    orientation: Orientation.EAST
  },
  //Tailors
  0x0d: {
    thumbnail: '/assets/images/thumbnails/Tailors/Tailors_blogpost_israel.jpg',
    imageUrl: '/assets/images/bigImages/Tailors/Tailors_blogpost_israel.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2019/05/axel-springer-tech-journey',
    description: 'ISRAEL Axel Springer Tech Journey',
    orientation: Orientation.NORTH
  },
  0x0e: {
    thumbnail: '/assets/images/thumbnails/Tailors/Tailors_blogpost_EventStorming.jpg',
    imageUrl: '/assets/images/bigImages/Tailors/Tailors_blogpost_EventStorming.jpg',
    blogPostUrl: 'https://www.ideas-engineering.io/blog/2019/04/event-storming',
    description: 'Event Storming: A System in Sticky Notes',
    orientation: Orientation.NORTH
  },
  //TEAM AI
  0x0f: {
    thumbnail: '/assets/images/thumbnails/MacCheese/wirvsvirus.png',
    imageUrl: '/assets/images/bigImages/MacCheese/wirvsvirus.png',
    blogPostUrl: 'https://medium.com/axel-springer-tech/wirvsvirushack-d761656fad0d',
    description: '#wirvsvirushack',
    orientation: Orientation.NORTH
  },
  0x10: {
    thumbnail: '/assets/images/thumbnails/TeamAI/TeamAI_blogpost_seq2seq.jpg',
    imageUrl: '/assets/images/thumbnails/TeamAI/TeamAI_blogpost_seq2seq.jpg',
    blogPostUrl: 'https://medium.com/axel-springer-tech/headliner-easy-training-and-deployment-of-seq2seq-models-2a26508b4dae',
    description: 'Headliner — Easy training and deployment of seq2seq models',
    orientation: Orientation.NORTH
  },
}